<template>
  <div class="space-y-5">
    <!-- Section header -->
    <div class="flex items-center gap-3">
      <span
        class="flex items-center justify-center flex-shrink-0 rounded-lg w-9 h-9 bg-taxiye-100 text-taxiye-500"
      >
        <span class="material-icons-round">payments</span>
      </span>
      <div class="min-w-0">
        <h3 class="text-base font-semibold text-gray-800">Corporate Pricing</h3>
        <p class="text-sm text-gray-500">Set fare rates for this corporate.</p>
      </div>
    </div>

    <form @submit.prevent class="space-y-5">
      <div class="p-5 space-y-4 border border-gray-200 bg-gray-50 rounded-2xl">
        <div class="grid grid-cols-2 gap-4">
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Price per KM</span>
            <input
              v-model="pricing.pricePerKM"
              class="w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
              type="number"
              placeholder="10"
            />
          </label>
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Price Per Min</span>
            <input
              v-model="pricing.pricePerMin"
              class="w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
              type="number"
              placeholder="10"
            />
          </label>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Base Fare</span>
            <input
              v-model="pricing.baseFare"
              class="w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300 text-sm"
              type="number"
              placeholder="10"
            />
          </label>
        </div>
      </div>

      <div>
        <button
          class="inline-flex items-center justify-center h-10 px-4 text-sm font-semibold text-white transition-colors duration-150 rounded-xl shadow-sm bg-taxiye-500 hover:bg-taxiye-600"
          @click="edit"
        >
          <span class="mr-1 text-base material-icons-round">save</span>
          Save Changes
        </button>
      </div>
    </form>
  </div>
</template>
<script>
// import moment from "moment";
export default {
  props: ["corporate"],
  data() {
    return {
      corporates: [],
      corporateData: {},
      pricing: {
        pricePerKM: 0,
        pricePerMin: 0,
        baseFare: 0,
      },
      loading: false,
    };
  },
  computed: {
    fareSum() {
      return this.corporateTrips.length
        ? this.corporateTrips
            .map(trip => trip.fare)
            .reduce((fare, current) => fare + current)
            .toFixed(2)
        : 0;
    },
  },
  watch: {
    corporate() {
      this.getCorporateTrips();
    },
    range: {
      deep: true,
      handler() {
        this.getCorporateTrips();
      },
    },
  },
  created() {
    console.log("this.$route.params.id", this.$route.params.id);
    this.getCorporate(this.$route.params.id).then(({ data }) => {
      // console.log(JSON.stringify(corporate, null, 2))
      this.corporateData = data;
      if (data.pricing) {
        this.pricing = data.pricing;
      }
    });
  },
  methods: {
    getCorporate(id) {
      return this.$http.get("/corporates/" + id);
    },
    edit() {
      if (this.corporateData && this.corporateData._id) {
        window.flash({
          type: "success",
          body: "Driver updated successfully!",
        });
        this.$http
          .patch(`/corporates/pricing/${this.corporateData._id}`, {
            pricePerKM: Number(this.pricing.pricePerKM),
            pricePerMin: Number(this.pricing.pricePerMin),
            baseFare: Number(this.pricing.baseFare),
          })
          .then(() => {
            this.getCorporate(this.corporate._id).then(({ data }) => {
              // console.log(JSON.stringify(corporate, null, 2))
              this.corporateData = data;
              if (data.pricing) {
                this.pricing = data.pricing;
              }
            });
          })
          .catch(err => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message &&
              err.response.data.message.includes("ValidationError")
            ) {
              window.flash({
                type: "error",
                body: err.response.data.message
                  .split(":")
                  .slice(1)
                  .join(":")
                  .split(",")
                  .join("<br/>"),
              });
              console.log(err);
            } else {
              window.flash({
                type: "error",
                body: "Driver couldn't be updated!",
              });
              console.log(err);
            }
          });
      }
    },
    formatDate(date) {
      // return moment(date).format("MMM D, YYYY HH:mm");
      return date ? date.replace("T", " ").slice(0, 16) : "-";
    },
  },
};
</script>
